<template>
  <main-layout>
    <v-tabs v-model="viewState" color="white" :slider-color="$vuetify.theme.primary">
      <v-tab href="#billing">{{ $t('Setting') }}</v-tab>
      <v-tab
        v-if="
          ['cds'].includes(selectedBot.type) || ['central-cds'].includes(selectedBot.page_group)
        "
        href="#salesforce-connect-management"
        >{{ $t('salesforce_connect.title') }}</v-tab
      >
      <v-tab
        v-if="
          ['cds'].includes(selectedBot.type) || ['central-cds'].includes(selectedBot.page_group)
        "
        href="#cenni-connect-management"
        >{{ $t('cenni_connect.title') }}</v-tab
      >
      <v-tab href="#social-connect-management">{{ $t('social_connect') }}</v-tab>
      <v-tab v-if="isPluginAvailable" href="#plugin">{{ $t('Plugin') }}</v-tab>
      <v-tab v-if="isTcpMainPage" href="#page-management">{{ $t('page_management') }}</v-tab>
      <v-tab v-if="showMenuSettingChatNotification" href="#chat-notification-setting">{{
        $t('setting_chat_notification')
      }}</v-tab>
    </v-tabs>
    <v-container fluid>
      <v-component :is="viewState" />
    </v-container>
  </main-layout>
</template>

<script>
import Billing from './Billing.vue'
import Plugin from './Plugin.vue'
import PageManagement from './PageManagement/PageManagement.vue'
import ChatNotificationSetting from './ChatNotificationSetting.vue'
import SocialConnectManagement from './SocialConnectManagement.vue'
import SalesforceConnectManagement from './SalesforceConnectManagement.vue'
import CenniConnectManagement from './CenniConnectManagement.vue'
import { PAGE } from '@/constants/page.js'
import { mapGetters } from 'vuex'

export default {
  components: {
    Billing,
    Plugin,
    PageManagement,
    ChatNotificationSetting,
    SocialConnectManagement,
    SalesforceConnectManagement,
    CenniConnectManagement
  },
  data() {
    return {
      viewState: 'billing'
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    }),
    isPluginAvailable() {
      return ['tcp'].includes(this.selectedBot.theme)
    },
    isTcpMainPage() {
      return PAGE.TCP_MAIN_PAGE.includes(this.selectedBot.pageid)
    },
    showMenuSettingChatNotification() {
      return ['nt'].includes(this.selectedBot.type)
    }
  },
  watch: {
    viewState() {
      this.updateRoute()
    }
  },
  mounted() {
    this.viewState = this.$route.query.tab || 'billing'
  },
  methods: {
    updateRoute: function () {
      const hashLists = ['#meta-catalog-success']
      this.$router.push({
        name: 'setting',
        path: '/billing',
        query: {
          tab: this.viewState
        },
        hash:
          this.$route.hash && hashLists.includes(this.$route.hash) ? this.$route.hash : undefined
      })
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/billing/SettingComponent.vue